/* eslint-disable @typescript-eslint/naming-convention */

import { gql } from "@apollo/client";
import { PostInfoV2 } from "./fragments";

export const GetHomepagePosts = /* GraphQL */ gql`
  ${PostInfoV2}
  query Get_Homepage_Posts(
    $post1: ID!
    $post2: ID!
    $post3: ID!
    $post4: ID!
    $post5: ID!
    $post6: ID!
    $post7: ID!
    $post8: ID!
    $post9: ID!
    $post10: ID!
    $post11: ID!
    $post12: ID!
    $post13: ID!
    $post14: ID!
    $post15: ID!
    $post16: ID!
    $post17: ID!
    $post18: ID!
    $post19: ID!
    $post20: ID!
    $post21: ID!
    $post22: ID!
    $post23: ID!
  ) {
    post1: getPost(id: $post1) {
      ...PostInfoV2
    }
    post2: getPost(id: $post2) {
      ...PostInfoV2
    }
    post3: getPost(id: $post3) {
      ...PostInfoV2
    }
    post4: getPost(id: $post4) {
      ...PostInfoV2
    }
    post5: getPost(id: $post5) {
      ...PostInfoV2
    }
    post6: getPost(id: $post6) {
      ...PostInfoV2
    }
    post7: getPost(id: $post7) {
      ...PostInfoV2
    }
    post8: getPost(id: $post8) {
      ...PostInfoV2
    }
    post9: getPost(id: $post9) {
      ...PostInfoV2
    }
    post10: getPost(id: $post10) {
      ...PostInfoV2
    }
    post11: getPost(id: $post11) {
      ...PostInfoV2
    }
    post12: getPost(id: $post12) {
      ...PostInfoV2
    }
    post13: getPost(id: $post13) {
      ...PostInfoV2
    }
    post14: getPost(id: $post14) {
      ...PostInfoV2
    }
    post15: getPost(id: $post15) {
      ...PostInfoV2
    }
    post16: getPost(id: $post16) {
      ...PostInfoV2
    }
    post17: getPost(id: $post17) {
      ...PostInfoV2
    }
    post18: getPost(id: $post18) {
      ...PostInfoV2
    }
    post19: getPost(id: $post19) {
      ...PostInfoV2
    }
    post20: getPost(id: $post20) {
      ...PostInfoV2
    }
    post21: getPost(id: $post21) {
      ...PostInfoV2
    }
    post22: getPost(id: $post22) {
      ...PostInfoV2
    }
    post23: getPost(id: $post23) {
      ...PostInfoV2
    }
  }
`;
